// apiService.js
import { useState, useEffect } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import config from 'config';
import useCustomToast from 'components/Toast/useCustomToast';

// Hook pour GET
export const useFetchData = (url) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const { error: showError } = useCustomToast();

  useEffect(() => {
    const getAuthHeaders = () => ({
      Authorization: `Bearer ${Cookies.get('token')}`
    });

    const fetchData = async () => {
      try {
        if (!url) {
          // no URL
          return;
        }

        if (Cookies.get('token')) {
          // Fetch data
          const response = await axios.get(`${config.apiUrl}/${url}`, {
            headers: getAuthHeaders()
          });

          if (response.status !== 200) {
            if (response.status === 403) {
              showError("Oops!", "Vous n'avez pas les droits pour effectuer cette action");
            } else if (response.status === 423) {
              showError("Erreur", "Votre compte est désactivé");
              Cookies.remove('token');
              window.location.reload();
            } else {
              showError("Erreur", "Impossible de charger les données");
            }
          }

          setData(response.data);
        }

      } catch (err) {
        setError(err);
        if (err.response && err.response.status === 403) {
          // Forbidden
        } else if (err.response.status === 423) {
          showError("Erreur", "Votre compte est désactivé");
          Cookies.remove('token');
          window.location.reload();
        } else {
          showError("Erreur", "Impossible de charger les données");
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [url]);

  return { data, isLoading, error };
};

// Hook pour POST
export const usePostData = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const { error: showError } = useCustomToast();

  const postData = async (url, data) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await axios.post(`${config.apiUrl}/${url}`, data, {
        headers: {
          Authorization: `Bearer ${Cookies.get('token')}`
        }
      });

      if (response.status !== 200) {
        showError("Erreur", "Impossible d'envoyer les données");
      }

      return response.data;
    } catch (err) {
      setError(err);
      if (err.response && err.response.status === 403) {
        showError("Oops!", "Vous n'avez pas les droits pour effectuer cette action");
      } else {
        showError("Erreur", "Impossible d'envoyer les données");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return { postData, isLoading, error };
};